import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FiltersModal } from './filters.modal';
import { AttributeFilterComponent } from './attribute-filter/attribute-filter.component';
import { PipesModule } from '../../pipes/pipes.module';

const routes: Routes = [
  {
    path: '',
    component: FiltersModal
  }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule
    ],
    declarations: [FiltersModal, AttributeFilterComponent],
    exports: [FiltersModal, AttributeFilterComponent]
})
export class FiltersModalModule {}
